import {Strings} from 'Strings';
import {jqueryPaymentLib} from 'lazy_modules';
import {SubscriptionsParams, SubscriptionCtrl} from './Subscriptions';
import {Utils} from 'underscore-extensions';
import {SubscriptionSvc} from '../services/SubscriptionSvc';
import {AnalyticSvc} from '../../services/AnalyticSvc';

class SubscriptionPlan {
    private SubscriptionCtrl: SubscriptionCtrl = this.$element.controller('subscription');

    constructor(private $scope: any,
                private $stateParams: SubscriptionsParams,
                private $element: ng.IAugmentedJQuery,
                private $ocLazyLoad: oc.ILazyLoad,
                private analyticSvc: AnalyticSvc,
                private subscriptionSvc: SubscriptionSvc) {
        $scope.upgradeModal = $scope.upgradeModal || {};
        Utils.sequence(jqueryPaymentLib, $ocLazyLoad).then(() => {
            if (!Strings.isBlank($stateParams.plan) && (!$stateParams.modal || $stateParams.modal === 'upgrade')) {
                $scope.upgradeModal.chosen = $stateParams.plan === $scope.upgrade.displayName;
                $scope.$apply();
            }
        });

        $scope.$watch('upgradeModal.chosen', (newVal?: string) => {
            newVal && this.analyticSvc.upgradeShown(
                this.$scope.action,
                this.$scope.upgrade.displayName
            );
            this.SubscriptionCtrl.responseError = '';
        });
    }

    handlerClick() {
        if (this.isFree()) {
            this.SubscriptionCtrl.toggleCancelModal()
        } else {
            this.showUpgradeDialog();
        }
    }

    isMostPopular() {
        return ['Pro', 'WavePro'].includes(this.$scope.upgrade.name);
    }

    getAnnualPrice() {
        return this.subscriptionSvc.getAnnualPrice(this.$scope.upgrade);
    }

    getMonthlyPrice() {
        return this.subscriptionSvc.getMonthlyPrice(this.$scope.upgrade);
    }

    isFree() {
        return this.subscriptionSvc.isFree(this.$scope.upgrade);
    }

    private showUpgradeDialog() {
        if (this.$scope.action === 'upgrade') {
            this.SubscriptionCtrl.showUpgradeModal(this.$scope.upgrade, this.$scope.billing.period);
        } else {
            this.$scope.upgradeModal.chosen = true;
        }
    }
}

angular.module('animatronApp.settings').directive('subscriptionPlan', () => ({
    restrict: 'E',
    transclude: true,
    require: '^subscription',
    controller: SubscriptionPlan,
    controllerAs: '$ctrl',
    templateUrl: require('upgrade/choose-plan.html')
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/subscriptionPlanDirective.ts